import * as React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Typography } from '@mui/material';

import { CurrencyFormat } from '@ha/intl';

import { useIntl } from '@kamernet/core/Intl';
import { NavLink } from '@kamernet/core/Routing/NavLink';

import { ListingDetailsContext } from '@kamernet/views/ListingDetails/ListingDetailsContext';

import styles from './RentalPrice.module.css';

export const RentalPrice = () => {
  const { T, formatCurrency } = useIntl();
  const { listingDetails } = ListingDetailsContext.useContext();
  const totalRentalPrice = listingDetails.totalRentalPrice
    ? formatCurrency(
        listingDetails.totalRentalPrice * 100,
        'EUR',
        CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION,
      )
    : '---';

  return (
    <div>
      <div className={styles.price}>
        <Typography variant="subtitle2">{totalRentalPrice}</Typography>
        <Typography variant="body3">{T('label.per_month')}</Typography>
        <NavLink.Native href="#cost-breakups">
          <InfoOutlinedIcon className={styles.infoButton} />
        </NavLink.Native>
      </div>
      <Typography variant="body4">
        {listingDetails.utilitiesIncluded
          ? T('ldp.incl_utilities')
          : T('ldp.excl_utilities')}
      </Typography>
    </div>
  );
};
